import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import './lib/mixpanel';
import './lib/performanceTest';
import { setupGlobalErrorHandlers } from './lib/errorLogger';

// Initialize global error handlers
setupGlobalErrorHandlers();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
